import { defineMessages } from 'react-intl';

export default defineMessages({
    userProfileTitle: {
        id: 'agency.admin.views.messages.Changes Saved',
        defaultMessage: 'Changes Saved'
    },
    userProfileMessage: {
        id: 'agency.admin.views.messages.Your changes have been saved.',
        defaultMessage: 'Your changes have been saved.'
    },
    confirmButtonText: {
        id: 'agency.admin.views.messages.confirmText',
        defaultMessage: 'OK'
    },
    // DE15456
    RoleValidationTitle: {
        id: 'twia.editUser.views.Please Select Role',
        defaultMessage: 'Please Select Role',
    },
    RoleValidationMessage: {
        id: 'twia.editUser.views.At least one role must be selected',
        defaultMessage: 'At least one role must be selected',
    },
    RoleButtonCloseMessage:{
        id: 'twia.editUser.views.Close',
        defaultMessage: 'Close',
    },
});